import { render, staticRenderFns } from "./RelatedProductCell.vue?vue&type=template&id=f16f7efe"
import script from "./RelatedProductCell.vue?vue&type=script&lang=js"
export * from "./RelatedProductCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports